// extracted by mini-css-extract-plugin
export default {"unavailable":"AveragePriceCell_unavailable__ezCcP"};